/**
 * ConnectionsStep Constants
 */

import type { MMPProvider, StoreType } from "./ConnectionsStep.types";

// MMP Provider options for dropdown
export const MMP_PROVIDER_OPTIONS: MMPProvider[] = ["adjust", "appsflyer", "none"];

// Store type options for multi-select
export const STORE_TYPE_OPTIONS: StoreType[] = ["android", "apple", "web", "whatsapp"];

// Extra keys in tracker source
export const TRACKER_EXTRA_KEYS = {
    PLATFORM: "platform",
    APP_ID: "app_id",
    MARKETPLACE_INSTALLED: "marketplace_installed",
    EVENT_PREFIX: "event_prefix",
} as const;

// Form field names
export const FORM_FIELD_NAMES = {
    TRACKER_ID: "tracker_id",
    MMP: "mmp",
    ONE_LINK: "one_link",
    APP_TYPE: "app_type",
    APPLICATIONS: {
        APPLE: "applications.apple",
        ANDROID: "applications.android",
        PHONE_NUMBER: "applications.phone_number",
    },
    TARGET_LINK: "target_link",
    LEAD_SOURCE_API_ID: "lead_source_api_id",
    GAMIFICATION_TYPE: "gamification_type",
} as const;

// Template names that require custom sources
export const TEMPLATES_REQUIRING_CUSTOM_SOURCES = ["lead", "funnel"] as const;

// Template names that require gamification
export const TEMPLATES_REQUIRING_GAMIFICATION = ["gamification"] as const;

